export const BeadedPatchesPageSeo = {
    title: "Handmade Beaded Patches — Custom Bead Embroidery, Wholesale & Bulk Orders | Arte Craft India",
    description:
        "Buy premium handmade beaded patches direct from manufacturer. Custom bead embroidery, appliqués, and motifs for fashion, bridal wear & accessories. 200+ designs, custom orders, wholesale MOQ from 50 pcs. Ships to 50+ countries. Est. 2017, New Delhi.",
    keywords:
        "handmade beaded patches, custom beaded patches, bead embroidery patches, beaded applique, beaded motifs, beaded patches wholesale, beaded patches manufacturer India, iron on beaded patches, sew on beaded patches, beaded patches for jackets, beaded patches for clothing, bridal beaded patches, beaded embroidery patches bulk, buy beaded patches online India",
    canonical: "https://www.artecraftindia.com/products/beaded-patches",
    author: "Arte Craft India",
    robots: "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
    ogType: "website",
    ogUrl: "https://www.artecraftindia.com/products/beaded-patches",
    ogSiteName: "Arte Craft India",
    ogImage: "https://www.artecraftindia.com/images/beaded-patches-og.jpg",
    ogImageAlt: "Handmade beaded embroidery patches and appliqués by Arte Craft India",
    ogLocale: "en_US",
    twitterCard: "summary_large_image" as const,
    twitterImage: "https://www.artecraftindia.com/images/beaded-patches-twitter.jpg",
};
